import GroupConversationCommunication from '~/pages/communication/groupConversation/libs/components/GroupConversationCommunication'
import { TPageProps } from '~/shared/types/commonTypes'

const GroupConversationCommunicationPage = (props: TPageProps) => (
  <GroupConversationCommunication {...props} />
)

export default GroupConversationCommunicationPage
